export default {
  groupProject: 'Projects',
  groupAdmin: 'Administration',
  groupSuperAdmin: 'Super Admin',
  photoLive: 'Photo Live',
  conference: 'Events',
  accountManage: 'Accounts',
  roleManage: 'Roles',
  permissionManage: 'Permissions',
  companyManage: 'Companies'
}
